export const isClickOutside = (e: Event, host: HTMLElement): boolean => {
  for (const element of e.composedPath()) {
    if (element && element === host) {
      return false;
    }
  }
  return true;
};
